<template>
  <!-- The birth component (BirthMoment) as a modal. Kept as its own name
       because surfaces already open it: Personal Horoscope (saves through
       saveBirthMoment) and the Studio's reader birth (updateReader, the old
       HH:MM shape). Emits `save` with both:
         { birthdate, birthtime, birthplace }  the legacy shape
         moment                                what POST /birth/moment/ takes -->
  <BirthMoment mode="modal" :title="title" :subtitle="subtitle" :initial="initial" :saving="saving"
               :server-errors="serverErrors || (error ? { _: error } : null)" :fields="fields" :optional="optional"
               :submit-label="submitLabel" :explain="explain"
               @save="onSave" @close="$emit('close')" />
</template>

<script setup>
import { computed } from 'vue'
import BirthMoment from '@/components/widgets/BirthMoment.vue'
import { ALL_FIELDS } from '@/utils/birth-moment'

const props = defineProps({
  title: { type: String, default: 'Your birth details' },
  subtitle: { type: String, default: 'Your birth date, time and place set your sun, moon & rising signs.' },
  // A moment from GET /birth/moment/ wins over the legacy fields below.
  moment: { type: Object, default: null },
  birthdate: { type: String, default: '' },
  birthtime: { type: String, default: '' },
  // { latitude, longitude } | null
  birthplace: { type: Object, default: null },
  saving: { type: Boolean, default: false },
  error: { type: String, default: '' },
  serverErrors: { type: Object, default: null },
  fields: { type: Array, default: () => ALL_FIELDS },
  // The one birthday card (navigation-design §10): the date required, time and place offered.
  optional: { type: Array, default: () => [] },
  submitLabel: { type: String, default: 'Save' },
  // The "What's this?" explainer (off for the Studio's Mystic birth).
  explain: { type: Boolean, default: true },
})
const emit = defineEmits(['save', 'close'])

const initial = computed(() => {
  if (props.moment) return props.moment
  if (!props.birthdate) return null
  const t = (props.birthtime || '').slice(0, 5)
  return {
    birthdate: props.birthdate.split('T')[0],
    time: t ? { kind: 'exact', value: t } : null,
    place: props.birthplace ? { ...props.birthplace } : null,
  }
})

function onSave(out) {
  const moment = { birthdate: out.birthdate, time: out.time, ...(out.place ? { place: out.place } : {}) }
  emit('save', { ...out.legacy, moment })
}
</script>
